import './plugins/vue-axios'
import './plugins/v-hotkey'
import './plugins/highcharts'
import './plugins/moment'
import './plugins/vue2-siema'
import './plugins/vue-meta'
import './plugins/i18n'
import './plugins/vue-lodash'
import './plugins/bootstrap-vue'
import './plugins/notifications'
import './plugins/vue-leader-line'
import './plugins/vue-uuid'
import './plugins/v-mask'
// import './components'

import './router/componentHooks'
import App from './App.vue'
// import {COUNTRIES_SNG, SERVERS_HOST_LIST} from '@/config'
import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import messages from './messages'
import router from './router'
import store from '@/store'
// import {sync} from 'vuex-router-sync'
import vuetify from './plugins/vuetify'

import i18n from "./helpers/i18n"

export const bus = new Vue();


import interceptorsSetup from './helpers/interseptors'

interceptorsSetup()

import barcode from 'tui-vue-barcode'

Vue.component('barcode', barcode)


Vue.config.productionTip = false



if (!localStorage.getItem('lang')) {
    localStorage.setItem('lang', 'ru')
    store.commit('locale/SetLang', 'ru')

} else {
    store.commit('locale/updateLocale', localStorage.getItem('lang'))
}


new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
